import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router';

// Lazy load guards and layouts
const HasToBeBackofficeGuard = lazy(() => import('app/core/guards/HasToBeBackofficeGuard'));
const HasToBeLoggedInGuard = lazy(() => import('app/core/guards/HasToBeLoggedInGuard'));
const DefaultLayout = lazy(() => import('app/core/layout/DefaultLayout'));
const Error404Page = lazy(() => import('app/main/errors/Error404Page'));

// Lazy load page components
const Projects = lazy(() => import('../../../../main/elevators/admin/projects/Projects'));

const ProjectDetails = lazy(() => import('../../../../main/elevators/admin/projects/project-details/ProjectDetails'));

// View exactly like agency view without edit options
const EquipmentDetails = lazy(() => import('../../../../main/elevators/agency/equipment-details/EquipmentDetails'));

// View exactly like user view TODO: provide user view when ready
const PaymentRequestView = lazy(() => import('../../../../main/elevators/agency/payment-request/PaymentRequestView'));

// View exactly like user view
const Certificates = lazy(() => import('../../../../main/elevators/certificates/Certificates'));

const ReportDetails = lazy(() => import('../../../../main/elevators/admin/report-details/ReportDetails'));

const Inspections = lazy(() => import('../../../../main/elevators/admin/inspections/Inspections'));

const PREFIX = '/admin/elevators';

export const adminElevatorsRoutes: RouteObject[] = [
  {
    path: PREFIX,
    element: (
      <HasToBeLoggedInGuard>
        <HasToBeBackofficeGuard>
          <DefaultLayout />
        </HasToBeBackofficeGuard>
      </HasToBeLoggedInGuard>
    ),
    errorElement: <Error404Page />,
    children: [
      {
        path: 'projects/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <ProjectDetails />
          </Suspense>
        ),
      },
      {
        path: 'equipment/:equipmentId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <EquipmentDetails />
          </Suspense>
        ),
      },
      {
        path: 'projects',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Projects />
          </Suspense>
        ),
      },
      {
        path: 'certificates',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Certificates />
          </Suspense>
        ),
      },
      {
        path: 'Inspections',
        element: (
          <Suspense fallback={<DataLoader />}>
            <Inspections />
          </Suspense>
        ),
      },
      {
        path: 'report/:id',
        element: (
          <Suspense fallback={<DataLoader />}>
            <ReportDetails />
          </Suspense>
        ),
      },
      {
        path: 'projects/:id/payment-request/:paymentRequestId',
        element: (
          <Suspense fallback={<DataLoader />}>
            <PaymentRequestView />
          </Suspense>
        ),
      },
    ],
  },
];
